/* eslint-disable no-undef */

import React, {PureComponent} from 'react'
import {withStyles} from "@material-ui/core/styles/index";
import InfoCard from "./InfoCard";

const styles = theme => ({});

class InfoCards extends PureComponent {

    render() {
        const {classes, infoCards, theme} = this.props;

        return (<>
                {infoCards.map((card, key) => (
                    <InfoCard
                        title={theme['infoCard' + (key + 1) + 'Title'] ?? ''}
                        body={theme['infoCard' + (key + 1) + 'Body'] ?? ''}
                        image={theme['infoCard' + (key + 1) + 'Image'] ?? ''}
                        icon={theme['infoCard' + (key + 1) + 'Icon'] ?? ''}
                        isIconImage={true}
                        key={key}
                    />
                ))}
            </>
        )
    }
}

export default withStyles(styles)(InfoCards);
